import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React, { useEffect, useState } from 'react'

import cardStaticStyles from '../../styles/components/homePage/card_static_styles'
import theme from '../../theme/news12'
import { useEnvironmentContext } from '../EnvironmentProvider'
import DurationPill from '../Story/RelatedStories/DurationPill'
import formatTime from '../utilities/format-time'
import getStoryHref from './getStoryHref'

import 'moment-duration-format'

const Card = ({ story, style, isHeroCard = false }) => {
  const [clientPublishedAt, setClientPublishedAt] = useState(null)
  const { canonicalUrlRedirects } = useEnvironmentContext()
  const href = getStoryHref(story, { canonicalUrlRedirects })

  useEffect(() => {
    if (story.publishedAt) {
      setClientPublishedAt(formatTime(story.publishedAt))
    }
  }, [story])

  return (
    <div className='card' data-testid='category-card'>
      <a className='card-content' href={href}>
        <div className='image-container'>
          <img className='image-hd' src={story.thumbnail} alt={`Story image: ${story.title}`} />
          {story.videoFile?.duration && <DurationPill duration={story.videoFile?.duration} style={style} />}
        </div>
        <div className='top'>
          {story.publishedAt && clientPublishedAt && <div className='timestamp'>{clientPublishedAt}</div>}
          <div className='meatball-icon' style={{ display: 'none' }}>
            <FontAwesomeIcon icon={faEllipsisH} size='sm' color={theme.colors.mourineGray} />
          </div>
        </div>
        <p className='card-title'>{story.title}</p>
        {isHeroCard && <p className='card-description'>{story.description}</p>}
      </a>
      <style jsx>{cardStaticStyles}</style>
      <style jsx>{style}</style>
    </div>
  )
}

export default Card
